export const lastSearchedWebsiteSelector = (state) => state.get('lastSearchedWebsite');
